module.exports = __webpack_public_path__ + "img/208.14116ece.jpg";